import { render, staticRenderFns } from "./peopleAndCarNoLogin.vue?vue&type=template&id=2ba2d61b&scoped=true&"
import script from "./peopleAndCarNoLogin.vue?vue&type=script&lang=js&"
export * from "./peopleAndCarNoLogin.vue?vue&type=script&lang=js&"
import style0 from "./peopleAndCarNoLogin.vue?vue&type=style&index=0&id=2ba2d61b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba2d61b",
  null
  
)

export default component.exports